import { SideBarListItemData } from "./types";
import Settings from "@mui/icons-material/Settings";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import People from "@mui/icons-material/People";
import PeopleOutline from "@mui/icons-material/PeopleOutline";
import { WorkspacesIcon } from "../../components/AppBar/icons/WorkspacesIcon";

export const items: SideBarListItemData[] = [
  {
    icon: WorkspacesIcon,
    iconSelected: WorkspacesIcon,
    text: "Project",
    route: "",
  },
  {
    icon: SettingsOutlined,
    iconSelected: Settings,
    text: "Project Configuration",
    route: "configuration/market-sizing",
  },
  {
    icon: PeopleOutline,
    iconSelected: People,
    text: "Customer Profile",
    route: "customer-profile",
  },
];
